package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.components.AppTextField
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.resources.AppResources

@Composable
fun ColumnScope.CostRangeCardView(
    costMin: Int?,
    costMax: Int?,
    currency: CurrencyUIModel,
    callbacks: SearchFilterCallbacks
) {
    CardView {
        Text(
            text = AppResources.strings.searchFilterPriceLabel,
            style = AppTextStyles.bodyMediumRegular,
            color = MaterialTheme.colors.onSurfacePrimary
        )
        AppSpacer(12.dp)
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth()
        ) {
            AppTextField(
                placeholder = AppResources.strings.searchFilterCostMinPlaceholder,
                onValueChange = {
                    if (it.isNotBlank()) {
                        it.toIntOrNull()?.let { callbacks.onCostMinValueChanged(it) }
                    } else {
                        callbacks.onCostMinValueChanged(null)
                    }
                },
                trailingIcon = currency.icon,
                value = costMin?.toString() ?: "",
                modifier = Modifier.weight(1f),
            )
            AppSpacer(8.dp)
            AppTextField(
                placeholder = AppResources.strings.searchFilterCostMaxPlaceholder,
                onValueChange = {
                    if (it.isNotBlank()) {
                        it.toIntOrNull()?.let { callbacks.onCostMaxValueChanged(it) }
                    } else {
                        callbacks.onCostMaxValueChanged(null)
                    }
                },
                trailingIcon = currency.icon,
                value = costMax?.toString() ?: "",
                modifier = Modifier.weight(1f),
            )
        }
    }
}